'use client'

import { useState } from 'react'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

import ListBots from './ListBots'

const selects = [
  {
    value: 'most-first',
    label: 'Time deployed ( most first )',
  },
  {
    value: 'least-first',
    label: 'Time deployed ( least first )',
  },
  {
    value: 'longest-first',
    label: 'Average duration ( longest first )',
  },
  {
    value: 'shortest-first',
    label: 'Average duration ( shortest first )',
  },
  {
    value: 'largest-first',
    label: 'Total profit ( largest first )',
  },
  {
    value: 'smallest-first',
    label: 'Total profit ( smallest first )',
  },
]

const BotStorePage = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { replace } = useRouter()
  const [value, setValue] = useState<string>(searchParams.get('filter') || selects[0].value)
  const handleSelect = (valueSelect: string) => {
    console.log({ valueSelect })
    const params = new URLSearchParams(searchParams)
    if (valueSelect === value) return
    params.set('filter', valueSelect)
    setValue(valueSelect)
    replace(`${pathname}?${params.toString()}`)
  }

  return (
    <div className="space-y-4">
      <p className="text-title text-center">Bot Store</p>
      <div className="grid w-full grid-cols-2 justify-start">
        <div className="w-full">
          <Select defaultValue={value} value={value} onValueChange={(e) => handleSelect(e)}>
            <SelectTrigger className="w-full border-0 text-base">
              <SelectValue placeholder="Select Bots" />
            </SelectTrigger>
            <SelectContent className="bg-tb-grayscale-800 text-tb-grayscale-100 border-white/10">
              <SelectGroup>
                {selects.map(({ value, label }, i) => (
                  <SelectItem key={i} value={value} className="text-base">
                    {label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>

        <div>
          <div className="border-b border-white/10">
            <input
              name="Bot Name"
              id="botname"
              required
              className="placeholder:text-tb-grayscale-500 w-full bg-transparent pb-2.5 text-base text-white outline-0"
              type="text"
              placeholder="Bot Name"
            />
          </div>
        </div>
      </div>

      <div className="h-[calc(100vh-210px)] overflow-hidden">
        <ListBots />
      </div>
    </div>
  )
}

export default BotStorePage
